import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=75936cce"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75936cce')) {
      api.createRecord('75936cce', component.options)
    } else {
      api.reload('75936cce', component.options)
    }
    module.hot.accept("./CompanyProfile.vue?vue&type=template&id=75936cce", function () {
      api.rerender('75936cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/CompanyProfile.vue"
export default component.exports